import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";

const Loader = () => {
    const [count, setCount] = useState(2);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const interval = setInterval(() => {
            setCount((prevValue) => --prevValue);
        }, 1000);

        count === 0 &&
            navigate(`/`, {
                state: location.pathname,
            });

        return () => clearInterval(interval);
    }, [count, navigate, location]);

    return (
      <>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            width: '100vw',
            overflow: 'hidden',
          }}
        >
          <Spinner color="#fa8f03" />
        </div>
      </>
    );
};

export default Loader;